<template>
  <v-snackbar
    id="ca-snackbar"
    v-model="show_snackbar"
    bottom
    :timeout="timeout"
    :class="{'ca-snackbar--error': error}"
  >
    <slot></slot>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    show: {type: Boolean, default: false}, // Se puede hacer sync ya que lanza update:show cuando cambia el estado
    timeout: {type: Number, default: 4000}, // Tiempo que se visualiza
    error: {type: Boolean, default: false} // Estiliza el fondo rojo y las letras blancas
  },
  data() {
    return {
      show_snackbar: this.show
    };
  },
  watch: {
    show(value) {
      if (value !== this.show_snackbar) {
        this.show_snackbar = value;
      }
    },
    show_snackbar(value) {
      // Sólo emito eventos si cambió valor
      if (value !== this.show) {
        this.$emit('update:show', value); // Evento para two-way binding de show con sync
        if (!value) {
          this.$emit('hide');
        }
      }
    }
  }
};
</script>
<style lang="scss">
  #ca-snackbar {
    margin-bottom: 65px;
    z-index: 1002;

    .v-snack__content {
      color: color(verde);
      border-radius: 4px;
    }
    .v-snack__wrapper {
      background-color: color(texto-oscuro);
      min-width: unset;
    }

    &.ca-snackbar--error {
      .v-snack__content {
        color: color(blanco);
      }
      .v-snack__wrapper {
        background-color: color(rojo);
      }
    }
  }
</style>
